import * as React from 'react';
import { v4 as uuid } from 'uuid';
import { requestStardogVoiceboxGenesis } from 'vet-bones/utils/voicebox';

import { notificationsActionCreators } from 'src/actions/notifications/actionCreators';
import { CompetencyQuestion } from 'src/constants/voicebox';
import { useDefaultPortalConnection } from 'src/utils/hooks/useDefaultPortalConnection';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { buildGenerateQuestionsParameters } from 'src/utils/voicebox/hooks/parameters';
import {
  GenerateQuestionsRequest,
  GenerateQuestionsResponse,
} from 'src/utils/voicebox/hooks/types';

export const useGenerateQuestions = () => {
  const dispatch = useReduxDispatch();
  const defaultConnection = useDefaultPortalConnection();

  return React.useCallback(
    async (
      name: string,
      description: string
    ): Promise<CompetencyQuestion[] | null> => {
      if (!defaultConnection) {
        return null;
      }

      let questions: CompetencyQuestion[] | undefined;

      try {
        const response = await requestStardogVoiceboxGenesis<
          GenerateQuestionsRequest,
          GenerateQuestionsResponse
        >({
          connectionIdx: defaultConnection.index,
          body: {
            endpoint: defaultConnection.endpoint,
            action: 'generate_questions',
            parameters: buildGenerateQuestionsParameters(name, description),
          },
        });

        if (response.error) {
          throw new Error(response.error);
        }

        questions = response.results?.questions.map((question) => ({
          id: uuid(),
          question: question.question,
        }));
      } catch (err) {
        dispatch(notificationsActionCreators.voiceboxGenerateQuestionsFailed());
      }

      return questions || null;
    },
    [defaultConnection, dispatch]
  );
};
